import { motion, useReducedMotion } from 'framer-motion';
import { fadeRight, inView, motionSafe, staggerContainer, staggerItem } from '@/lib/motion';

const printSteps = [
  'Round Completed',
  'Results Reviewed',
  'Approved',
  'Official PDF',
  'Print',
  'Notice Board',
  'Online Results',
];

export function PrintPreview() {
  const reduce = useReducedMotion();
  const stepsMotion = motionSafe(reduce, staggerContainer(0.07));
  const sheetMotion = motionSafe(reduce, fadeRight);

  return (
    <div className="mt-6 grid items-start gap-6 lg:grid-cols-[0.9fr_1.1fr]">
      <motion.ol
        className="space-y-2"
        aria-label="Official results print workflow"
        {...stepsMotion}
        viewport={inView}
      >
        {printSteps.map((step, index) => (
          <motion.li
            key={step}
            variants={reduce ? undefined : staggerItem}
            className="flex items-center gap-3 text-sm"
          >
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-navy text-xs font-bold text-white">
              {index + 1}
            </span>
            <span className="font-medium text-navy">{step}</span>
          </motion.li>
        ))}
      </motion.ol>

      <motion.div
        className="mx-auto aspect-[210/297] w-full max-w-[240px] overflow-hidden rounded-sm border border-border bg-white shadow-[0_20px_50px_-28px_rgba(0,36,71,0.5)]"
        aria-hidden="true"
        {...sheetMotion}
        viewport={inView}
      >
        <div className="flex h-full flex-col p-[6%]">
          <div className="flex items-start justify-between border-b border-navy/15 pb-3">
            <div>
              <p className="font-display text-sm font-bold text-navy">Overall Results</p>
              <p className="text-[10px] text-muted-foreground">Competition branding · Official</p>
            </div>
            <div className="h-8 w-8 rounded border border-dashed border-navy/30" />
          </div>
          <div className="mt-3 flex-1 space-y-1.5 text-[9px] leading-relaxed text-navy/80">
            {['1 · A. Rivera · 48 cm', '2 · M. Chen · 51 cm', '3 · S. Okada · 63 cm', '4 · J. Silva · 71 cm'].map(
              (line, i) => (
                <motion.div
                  key={line}
                  className="flex justify-between border-b border-border/80 py-1"
                  initial={reduce ? false : { opacity: 0, x: 8 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={inView}
                  transition={{ delay: 0.25 + i * 0.08, duration: 0.35 }}
                >
                  <span>{line.split(' · ').slice(0, 2).join(' · ')}</span>
                  <span className="tabular-nums">{line.split(' · ').at(-1)}</span>
                </motion.div>
              ),
            )}
            <div className="pt-3 text-[8px] text-muted-foreground">
              Page 1 of 2 · Generated with timestamp · QR to live results
            </div>
          </div>
          <div className="mt-auto grid grid-cols-2 gap-4 border-t border-navy/10 pt-3">
            <div className="h-8 border-b border-navy/25" />
            <div className="h-8 border-b border-navy/25" />
          </div>
          <p className="mt-1 text-[7px] text-muted-foreground">Signatures where configured</p>
        </div>
      </motion.div>
    </div>
  );
}
